import { chatTypes } from "./chat.types"

export const addMessageStart = (payload) => {
    return (dispatch) => {
        dispatch({
            type:chatTypes.ADD_CHAT_MESSAGE,
            payload
        })
    }
}

export const getMessageStart = (payload) => {
    return (dispatch) => {
        dispatch({
            type:chatTypes.GET_MESSAGES,
            payload
        })
    }
}

export const setMessageStart = (payload) => {
    return {
        type:chatTypes.SET_MESSAGE,
        payload
    }
}

export const setMessagesStart = (payload) => {
    return {
        type:chatTypes.SET_MESSAGES,
        payload
    }
}

export const setMessagesFailStart = () => {
    return {
        type:chatTypes.SET_MESSAGES_FAILED
    }
}